type OperationsManagerCompany = {
    ops_manager_id?: string | number | null;
    ops_manager_name?: string | null;
};

/** A cleared assignment stays cleared, even when a legacy response alias exists. */
export function getCompanyOperationsManagerId(company: OperationsManagerCompany): string {
    const value = company.ops_manager_id;
    if (value == null || value === "") return "";
    const id = Number(value);
    return Number.isSafeInteger(id) && id > 0 ? String(id) : "";
}

export function getCompanyOperationsManagerName(company: OperationsManagerCompany): string {
    const id = getCompanyOperationsManagerId(company);
    return id ? String(company.ops_manager_name ?? "").trim() || `מנהל תזרים ${id}` : "";
}

export function getCompanyOperationsManagerOptions(companies: readonly OperationsManagerCompany[]) {
    const managers = new Map<string, string>();
    for (const company of companies) {
        const id = getCompanyOperationsManagerId(company);
        if (!id) continue;
        const name = String(company.ops_manager_name ?? "").trim();
        if (!managers.has(id) || name) managers.set(id, name || `מנהל תזרים ${id}`);
    }
    return Array.from(managers, ([id, label]) => ({id, label, searchText: label}))
        .sort((left, right) => left.label.localeCompare(right.label, "he"));
}
